import { getServerRequestContext } from '@coolblue-development/next-request-context/server';
import { getRouteContext } from '@coolblue-development/next-routing/server';
import type { MouseEventHandler } from 'react';

const GRAPHQL_MAX_INT = 2_147_483_647 as const;

export function debounceCallback(func: () => void, delay: number): () => void {
  let timeoutId: ReturnType<typeof setTimeout>;

  return () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(func, delay);
  };
}

export function getHeaderElement() {
  return document.getElementsByTagName('header')?.[0];
}

function getHeaderOffset() {
  const headerElement = getHeaderElement();

  if (!headerElement) {
    return 0;
  }

  return headerElement.offsetHeight + 10;
}

export function scrollToTarget(id: string, offset?: number): MouseEventHandler<HTMLAnchorElement> {
  return function (event) {
    event.preventDefault();
    const element = document.getElementById(id);

    if (!element) {
      return;
    }

    const elementOffset = element.offsetTop;
    window.scrollTo(0, elementOffset - (offset || getHeaderOffset()));
  };
}

export function capitalizeStringFirstLetter(string: string): string {
  return String(string).charAt(0).toUpperCase() + String(string).slice(1);
}

export async function showMigrationProgress(): Promise<boolean> {
  const route = await getRouteContext();
  const { isInternalUser } = await getServerRequestContext();

  return isInternalUser && 'preCart.productWithSlug' === route.name;
}

// Validate the productId to ensure it is a positive number.
export function isInvalidProductId(productId: string): boolean {
  const parsedId = Number(productId);
  return isNaN(parsedId) || parsedId <= 0 || parsedId > GRAPHQL_MAX_INT;
}

const PRE_ORDER_IPHONE_17_LIST = [
  969443, 969442, 968965, 969446, 969444, 969445, 969449, 969447, 969448, 969451, 969450, 968966,
  969454, 969452, 969453, 969457, 969455, 969456, 969460, 969458, 969459
];

export const getIsIphonePreOrder = (productId: number) =>
  PRE_ORDER_IPHONE_17_LIST.includes(productId);

export const MIN_TOUCH_TARGET_SIZE = '24px';
